import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

import { authApi } from '../../../../../utilities/axios';
import { useAuthStore } from '../../../../../modules/auth/store';
import { showToast } from '../../../../../utilities/toast-handler';
import { formatTreeData } from '../../../../../utilities/json-formatter';
const CATEGORY_URL = process.env.VUE_APP_API_VERSION + '/template/category';
const ASSESSMENT_CATEGORY_URL = process.env.VUE_APP_API_VERSION + '/template/assessment/categories';

export const useCategoryStore = defineStore('category', () => {
    const authStore = useAuthStore();
    const company_id = computed(() => {
        return authStore.getLoggedUserCompanyId;
    });
    // states
    const category = ref({
        company_id: null,
        name: null,
        parent_id: null,
    });
    const categories = ref([]);
    const assessmentCategories = ref([]);

    // getters
    const allCategories = computed(() => {
        return formatTreeData(categories.value);
    });

    // actions
    const fetchCategories = async (assessmentType = false) => {
        try {
            const URL = assessmentType ? ASSESSMENT_CATEGORY_URL : CATEGORY_URL;
            const response = await authApi.get(URL, {
                params: {
                    company_id: company_id.value,
                },
            });
            if (response.statusCode === 200) {
                assessmentType ? (assessmentCategories.value = response.data) : (categories.value = response.data);
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to fetch categories');
        }
    };

    return {
        // states
        category,
        categories,
        assessmentCategories,
        // getters
        allCategories,
        // actions
        fetchCategories,
    };
});
